import React, { FC, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';
import Button from 'ati-ui-react/components/Button';
import Link from 'ati-ui-react/components/Link';
import { addMetric } from 'utils/addMetrics';
import TechData from './components/TechData';
import Restrictions from './components/Restrictions';
import Owners from './components/Owners';
import Accidents from './components/Accidents';
import AllHistoryButton from './components/AllHistoryButton';

import { FullReportContainer } from './FullVinReportStyles';

interface IProps {
  openComplaintPopup?: () => void;
  close: () => void;
}

const FullVinReport: FC<IProps> = observer(({ openComplaintPopup, close }) => {
  const {
    checksStore: { getTransportFullReport },
    advertsStore: {
      // TODO поправить когда перейдут сторы на TS
      // @ts-ignore
      currentAdvert: { _id, is_owner },
    },
  } = useStores();

  useEffect(() => {
    getTransportFullReport(_id);
  }, []);

  useEffect(() => {
    if (is_owner) {
      addMetric('checker-report-popup-owner');
    }
  }, []);

  useEffect(() => {
    if (!is_owner) {
      addMetric('checker-report-popup');
    }
  }, []);

  return (
    <FullReportContainer>
      <TechData />
      <Restrictions />
      <Owners />
      <Accidents />
      <AllHistoryButton />
      <div className="actions">
        <Button className="button" onClick={close}>
          Закрыть
        </Button>
        <Link type="pseudo" small onClick={openComplaintPopup}>
          Сообщить о неточных данных
        </Link>
      </div>
    </FullReportContainer>
  );
});

export default FullVinReport;
